module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-field",
    class: [{
      'cb-field--active': (_vm.internalValue || _vm.focussed || _vm.isDate)
    }, _vm.customClass, {
      'cb-field--error': (!!_vm.errorMessage && !_vm.focussed)
    }, {
      'cb-field--sibling': _vm.siblingError
    }, {
      'cb-field--focus': _vm.focussed && !_vm.readonly
    }, {
      'cb-field--select-alt': this.config.meta.help_text
    }]
  }, [_c('input', {
    ref: "input",
    staticClass: "cb-field__control",
    class: {
      'cb-field__readonly': _vm.readonly
    },
    attrs: {
      "type": _vm.getType,
      "readonly": _vm.readonly,
      "placeholder": _vm.isDate && _vm.placeholderText,
      "autocomplete": _vm.autocompleteMapping,
      "name": _vm.autocompleteMapping ? _vm.autocompleteMapping : _vm.name,
      "aria-disabled": _vm.readonly,
      "disabled": _vm.readonly,
      "aria-required": _vm.required,
      "id": _vm.name,
      "aria-autocomplete": _vm.enableScreenReader && 'inline',
      "aria-describedby": _vm.enableScreenReader && 'initInstr'
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "click": function($event) {
        _vm.focus($event)
      },
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "input": function($event) {
        _vm.input($event)
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.navigate($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.navigate($event)
      }, function($event) {
        _vm.keyup($event)
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cb-field__label",
    class: {
      'cb-field__label--s': _vm.isShort
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.displayLabel))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (this.config.meta.help_text) ? _c('div', {
    staticClass: "cb-field__help"
  }, [
    [_c('div', {
      ref: "helpText",
      staticClass: "cb-field__trigger",
      class: {
        'active-opacity': _vm.helpTextShown
      },
      on: {
        "click": function($event) {
          _vm.showHelpText($event)
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "help-text"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.helpTextShown),
        expression: "helpTextShown"
      }],
      staticClass: "cb-field__menu"
    }, [_vm._v("\n          " + _vm._s(this.config.meta.help_text) + "\n        ")])])]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.errorMessageWrapper && !_vm.focussed) ? _c('div', {
    staticClass: "cb-field__error"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessageWrapper) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "no-display",
    attrs: {
      "id": "initInstr"
    }
  }, [_vm._v("When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bde3111"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/TextField.vue
// module id = 116
// module chunks = 66 67 68 69